import type { ConfigType } from '@plone/registry';
import AnalyticsSlot from '@ifpb/portal/components/Slots/AnalyticsSlot';
import SocialNetworksSlot from '@ifpb/portal/components/Slots/SocialNetworksSlot';
import type { Content } from '@plone/types';

export function hasInheritedBehavior(behavior: string) {
  return ({ content }: { content: Content }) =>
    Object.keys(content?.['@components']?.inherit || {}).includes(behavior);
}

export default function install(config: ConfigType) {
  config.registerSlotComponent({
    name: 'SocialNetworksSlots',
    slot: 'navigationTools',
    component: SocialNetworksSlot,
  });
  // Register AnalyticsSlot in the postFooter slot
  config.registerSlotComponent({
    name: 'AnalyticsSlot',
    slot: 'postFooter',
    component: AnalyticsSlot,
  });
  return config;
}
